module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/basketball-0bfb1c9772ba700ffed42ffe14676c24.svg";